export const ruleData = [
  {
    name: '收件人姓',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 1
  },
  {
    name: '收件人名',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 2
  },
  {
    name: '收件人姓+收件人名',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 3
  },
  {
    name: '手机/电话区号',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 4
  },
  {
    name: '手机/电话(不含区号)',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 5
  },
  {
    name: '手机/电话区号+手机/电话(不含区号)',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 6
  },
  //   {
  //     name: '邮箱',
  //     regularDesc: '',
  //     regularExpression: '',
  // webRegularExpression: '',
  // appRegularExpression: '',
  //     required: null,
  //     errorPromptDTOList: [
  //       {
  //         lang: 'English',
  //         langCode: 'en-GB',
  //         prompt: ''
  //       }
  //     ],
  //     type: 7
  //   },
  {
    name: '国家',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 8
  },
  {
    name: '省州',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 9
  },
  {
    name: '城市',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 10
  },
  {
    name: '地址1',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 11
  },
  {
    name: '地址2',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 12
  },
  {
    name: '地址1+地址2',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 13
  },
  {
    name: '邮编',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 14
  },
  {
    name: '税号',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 15
  },
  {
    name: '身份证号',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 16
  },
  {
    name: 'Po Box',
    isShow: true,
    showFlag: null,
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 17
  },
  {
    name: '地址1+地址2+Po Box',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 18
  },
  {
    name: '地址2+Po Box',
    regularDesc: '',
    regularExpression: '',
    webRegularExpression: '',
    appRegularExpression: '',
    required: null,
    errorPromptDTOList: [
      {
        lang: 'English',
        langCode: 'en-GB',
        prompt: ''
      }
    ],
    type: 19
  }
]
